<template>
  <v-hover v-slot="{ isHovering, props }">
    <div
      v-if="!noLabel"
      class="legend-section"
      :class="{ 'legend-section-hover': toggleEnabled && isHovering }"
      v-bind="props"
    >
      <div :class="{'legend-section-opaque': !groupIsVisible}">
        {{ legendGroup.label }}
      </div>
      <v-btn
        v-if="toggleEnabled"
        :icon="groupIsVisible ? `mdi-eye-outline` : `mdi-eye-off-outline`"
        variant="text"
        class="legend-section-icon"
        :style="(isHovering || !groupIsVisible) ? 'visibility: visible' : 'visibility: hidden'"
        @click="$emit('toggle-group-visibility', legendGroup.uid, !groupIsVisible)"
      />
    </div>
  </v-hover>
  <div>
    <LegendItem
      v-for="(legendItem, i) in legendGroup.legendSymbols"
      :key="`${legendGroup.label}-${i}`"
      :legend-item="legendItem"
      :legend-toggle-enabled="toggleEnabled"
      @toggle-item-visibility="(itemId, visible) => $emit('toggle-item-visibility', legendGroup.uid, itemId, visible)"
    />
  </div>
</template>

<script lang="ts">
import LegendItem from '@/components/LayersMenu/sections/Legend/LegendItem.vue';
import {PropType} from 'vue';
import {LegendGroup} from '@/lib/classes/Legend/LegendGroup';

export default {
  name: 'LegendGroup',
  components: {
    LegendItem,
  },
  props: {
    legendGroup: {
      type: Object as PropType<LegendGroup>,
      required: true,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    disableToggle: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle-group-visibility', 'toggle-item-visibility'],
  computed: {
    toggleEnabled(): boolean {
      return this.legendGroup.legendToggleEnabled && !this.disableToggle;
    },
    groupIsVisible(): boolean {
      return this.legendGroup.isVisible();
    },
  },
};
</script>

<style lang="scss" scoped>
.legend-section {
  display: flex;
  font-family: main.$fontPrimary;
  color: #666;
  font-weight: 800;
  align-items: center;
  justify-content: space-between;

  &-hover {
    cursor: pointer;
    background-color: main.$lightGray;
  }

  &-opaque {
    opacity: 0.5;
  }

  &-icon {
    max-height: 26px;
    max-width: 26px;
    padding: 0px;
    padding-top: 2px;

    :deep(i) {
      font-size: 21px;
    }

    // make the hover background larger than the button itself
    &:hover {
      :deep(.v-btn__overlay) {
        background-color: main.$midGray;
        opacity: 100%;
        top: -2px;
        left: -3px;
        width: 120%;
        height: 120%;
      }
    }
  }
}
</style>
